import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Parse from "parse";

import { useGame, useTimer } from "../header/GameContext";
import Header from "../header/header";
import { saveToSheet } from "../../api/sheet";
import { hasSurveyRow } from "../../api/surveyApi";

import "./clear.css";

//IMG import
import coneImg from "../../img/clear/img_cone-big.png";

//유저 정보 가져오기
const PARSE_APP_ID = "iSAfLB3Yu649eDt2gvCbJg9LHU7RbsYhzpdzMLSR";
const PARSE_JS_KEY = "cXuIq8tOiwtopr2fNcEGkpBcnf21kPOLwF5bRqUH";
const PARSE_SERVER = "https://parseapi.back4app.com/";

const ensureParse = () =>
  new Promise((resolve) => {
    const init = () => {
      if (!window._parseReady) {
        window.Parse.initialize(PARSE_APP_ID, PARSE_JS_KEY);
        window.Parse.serverURL = PARSE_SERVER;
        window._parseReady = true;
      }
      resolve(window.Parse);
    };
    if (window.Parse) {
      init();
      return;
    }
    const s = document.createElement("script");
    s.src = "https://npmcdn.com/parse/dist/parse.min.js";
    s.onload = () => init();
    document.head.appendChild(s);
  });

const getSharedUserData = async (playerKeyCode) => {
  try {
    await ensureParse();
    const query = new Parse.Query(Parse.Object.extend("spyx"));
    query.equalTo("keyCode", playerKeyCode);
    const user = await query.first();
    console.log("공유 유저 조회:", user ? user.toJSON() : "없음");
    return user;
  } catch (e) {
    console.error("유저 정보 가져오기 실패:", e);
    return null;
  }
};

export default function Clear({ timerMode = "pause" }) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [searchParams] = useSearchParams();
  const sharedKeyCode = searchParams.get("code");
  const isSharedView = !!sharedKeyCode;

  const {
    playerName,
    playerKeyCode,
    startTimer,
    pauseTimer,
    TOTAL_GAME_TIME,
    correctCount,
    suspectScore,
  } = useGame();

  const [hasSurvey, setHasSurvey] = useState(false);

  const userId = localStorage.getItem("gameUserId");

  const { time } = useTimer();
  const [sharedUserData, setSharedUserData] = useState(null);

  // 공유링크로 접근 시 DB에서 데이터 가져오기
  useEffect(() => {
    if (!isSharedView) return;
    getSharedUserData(sharedKeyCode).then((user) => {
      if (user) setSharedUserData(user);
    });
  }, [sharedKeyCode]);

  const displayName = isSharedView
    ? (sharedUserData?.get("playerName") ?? "-")
    : playerName;

  /* =========================
     최종 추론 점수
  ========================= */
  const finalQuizScore = correctCount * 10;
  const TotalQuizScore = isSharedView
    ? (sharedUserData?.get("score") ?? "-")
    : finalQuizScore + suspectScore;

  /* =========================
     타이머 제어
  ========================= */
  useEffect(() => {
    if (isSharedView) return;
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode, startTimer, pauseTimer]);

  /* =========================
     탈출 시간
  ========================= */
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}분 ${s < 10 ? "0" : ""}${s}초`;
  };

  const escapeTime = isSharedView
    ? sharedUserData
      ? formatTime(sharedUserData.get("clearTime"))
      : "로딩 중..."
    : (() => {
        const adminTime =
          Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
          Number(TOTAL_GAME_TIME) ||
          0;
        const remainTime =
          Number(localStorage.getItem("GAME_TIME_REMAIN")) || Number(time) || 0;
        const usedTime = adminTime - remainTime;
        return usedTime > 0 ? formatTime(usedTime) : "-";
      })();

  /* =========================
     공유 버튼
     playerKeyCode 없을 때 localStorage 폴백
  ========================= */
  const handleShare = async () => {
    const keyCode =
      playerKeyCode || localStorage.getItem("PLAYER_KEY_CODE") || "";
    if (!keyCode) {
      alert("공유 코드를 찾을 수 없습니다. 다시 시도해주세요.");
      return;
    }
    try {
      const shareUrl = `${window.location.origin}/clear?code=${keyCode}`;
      await navigator.clipboard.writeText(shareUrl);
      alert("URL이 클립보드에 복사되었습니다.");
    } catch (e) {
      alert("복사에 실패했습니다.");
    }
  };

  // 설문 참여 여부 확인
  useEffect(() => {
    const checkSurvey = async () => {
      const result = await hasSurveyRow(userId);

      setHasSurvey(result);
    };

    if (userId) {
      checkSurvey();
    }
  }, [userId]);

  return (
    <div id="content">
      {!isSharedView && <Header isFinalQuiz={true} />}

      <div
        className={`box content_box1 ans0001 clearBox ${isSharedView ? "shared_clearBox" : ""}`}
      >
        <div className="box_con con_box1 con_pd5 con_box_c">
          <div className="mission_tit clearTit"></div>

          <p className="clearBT mt40">방탈출 성공!</p>

          <div className="clear_coneImg mt16">
            <img src={coneImg} alt="꼬네" />
          </div>

          <div className="clearInfoBox mt16">
            {isSharedView && <p className="clearBTxt">이름: {displayName}</p>}
            <p className="clearBTxt">클리어 시간: {escapeTime}</p>
            <p className="clearBTxt">최종 점수: {TotalQuizScore}점 / 80점</p>

            <p className="clearSTxt mt16">[60-80점] 완벽한 탐정!</p>
            <p className="clearSTxt">[40-59점] 우수한 추리!</p>
            <p className="clearSTxt">[20-39점] 재도전 권장</p>
            <p className="clearSTxt">[0-19점] 단서 재검토 필요</p>

            <p className="clearTxt mt24">방탈출에 성공했음을 인증합니다.</p>
          </div>

          {!isSharedView && (
            <div id="box_ft">
              <button
                type="button"
                className="inputBtn02 btnCode mt16"
                onClick={() => navigate("/ranking")}
              >
                랭킹 확인하기
              </button>
              <button
                type="button"
                className="inputBtn02 btnCode mt16"
                onClick={() => {
                  if (hasSurvey) {
                    alert("이미 설문조사에 참여하셨습니다.");
                    return;
                  }

                  navigate("/survey/1");
                }}
              >
                체험 의견 전달하기
              </button>
              <p className="nextFlowInfo mt16">
                *설문은 오늘 프로그램에 대한 의견을
                <br />
                듣기 위해 마련되었습니다.
                <br />
                응답 내용은 향후 프로그램 개선을 위한
                <br />
                기초 자료로 활용됩니다.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
